import { faMap } from "@fortawesome/free-regular-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Layout from "../../components/layout";
import { MapContainer, Marker, TileLayer } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import logo from "../../assets/images/logo_tiara.png";

const Contact = () => {
  return (
    <Layout>
      <section className='container mx-auto flex '>
        <div className='flex-1 border lg:ml-8 bg-white'>
          <div className='p-2 font-bold border-b border-solid'>
            تماس با تیارا
          </div>
          <div className='p-4'>
            <div className='grid lg:grid-cols-2 grid-cols-1 gap-2 '>
              <div className='w-full overflow-hidden h-80 z-0'>
                {/* <iframe
                  src='https://balad.ir/embed?p=1mD42slN5hz1Dy'
                  title='مشاهده «رستوران تیارا» روی نقشه بلد'
                  width='100%'
                  height='100%'
                  aria-hidden='false'
                ></iframe> */}
                <MapContainer
                  className='h-80'
                  center={[31.294992331159847, 48.641390331260936]}
                  zoom={16}
                  scrollWheelZoom={false}
                >
                  <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
                  />
                  <Marker
                    position={[31.294992331159847, 48.641390331260936]}
                    icon={
                      new L.Icon({
                        iconUrl: logo,
                        iconRetinaUrl: logo,
                        iconSize: new L.Point(48, 48),
                        className: "leaflet-div-icon border-0 tiara_map_marker",
                      })
                    }
                  ></Marker>
                </MapContainer>
              </div>
              <div>
                <div className='p-2'>
                  <FontAwesomeIcon icon={faMap} />
                  <span>
                    اهواز٬ گلستان٬ بلوار فروردین٬ بین آبان و آذر٬ ساختمان طبقاتی
                    تیارا٬ پلاک ۱۵۷
                  </span>
                </div>
                <div className='p-2'>
                  <FontAwesomeIcon icon={faPhone} />
                  <a href='tel:0613501'>061-3501</a>
                </div>

                <div className='p-2'>
                  <FontAwesomeIcon icon={faPhone} />
                  <a href='tel:06133210777'>061-33210777</a>
                </div>

                <div className='p-2'>
                  <FontAwesomeIcon icon={faPhone} />
                  <a href='tel:06133210444'>061-33210444</a>
                </div>

                <div className='p-2'>
                  <FontAwesomeIcon icon={faPhone} />
                  <a href='tel:06133210888'>061-33210888</a>
                </div>

                <div className='p-2'>
                  <FontAwesomeIcon icon={faPhone} />
                  <a href='tel:06133210666'>061-33210666</a>
                </div>

                <div className='p-2'>
                  <FontAwesomeIcon icon={faPhone} />
                  <a href='tel:09334993501'>09334993501</a>
                </div>

                <div className='p-2'>
                  <FontAwesomeIcon icon={faPhone} />
                  <a href='tel:09396013501'>09396013501</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Contact;
